"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCulture = useCulture;
var _react = require("react");
var _contexts = require("../contexts");
/**
 * Returns stored language, culture settings, financial settings and timezone identification.
 *
 * @returns Language, culture settings, financial settings and timezome identification.
 * @example
  const { language, culture, financialSet, timeZone } = useCulture();
 */
function useCulture() {
  return (0, _react.useContext)(_contexts.cultureContext);
}
//# sourceMappingURL=useCulture.js.map